<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <label class="configurationBannerLabel">Mechanical Options</label>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationDetailRow">
        <div class="halfWidthConfigurationInput">
          @if (returnAirLocationSelection) {
            <div class="modConnectionRow">
              <label class="modConnectionLabel">Return Location:</label>
              <select class="modConnectionField" #returnLocationInput
                [class.invalidConfigurationSelection]="isInvalidSelection(returnAirLocationSelection.Name)"
                (change)="selectionChanged(returnAirLocationSelection, returnLocationInput.value)"
                [value]="returnAirLocationSelection.Value.toString()">
                @for (allowable of returnAirLocationSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="returnAirLocationSelection.Value && returnAirLocationSelection.Value.toString() === allowable.Value"
                    [value]="allowable.Value">{{ allowable.Description }}
                  </option>
                }
              </select>
            </div>
          }
          @if (frontSupplySelection) {
            <div class="modConnectionRow">
              <label [class.invalidConfigurationSelection]="isInvalidSelection(frontSupplySelection.Name)"
              for="frontSupplyInput" class="modConnectionLabel">Front Supply:</label>
              <input type="checkbox" class="checkboxInput" id="frontSupplyInput"
                #frontSupplyInput [checked]="'true' === frontSupplySelection.Value"
                (change)="selectionChanged(frontSupplySelection, frontSupplyInput.checked.toString())">
              @if (topSupplySelection) {
                <span>
                  <label [class.invalidConfigurationSelection]="isInvalidSelection(topSupplySelection.Name)"
                  for="topSupplyInput" class="modConnectionCheckboxLabel">Top Supply:</label>
                  <input type="checkbox" class="checkboxInput" id="topSupplyInput"
                    #topSupplyInput [checked]="'true' === topSupplySelection.Value"
                    (change)="selectionChanged(topSupplySelection, topSupplyInput.checked.toString())">
                </span>
              }
            </div>
          }
          @if (leftSupplySelection) {
            <div class="modConnectionRow">
              <label [class.invalidConfigurationSelection]="isInvalidSelection(leftSupplySelection.Name)"
              for="leftSupplyInput" class="halfWidthInputLabel">Left Supply:</label>
              <input type="checkbox" class="checkboxInput" id="leftSupplyInput"
                #leftSupplyInput [checked]="'true' === leftSupplySelection.Value"
                (change)="selectionChanged(leftSupplySelection, leftSupplyInput.checked.toString())">
              @if (rightSupplySelection) {
                <span>
                  <label [class.invalidConfigurationSelection]="isInvalidSelection(rightSupplySelection.Name)"
                  for="rightSupplyInput" class="modConnectionCheckboxLabel">Right Supply:</label>
                  <input type="checkbox" class="checkboxInput" id="rightSupplyInput"
                    #rightSupplyInput [checked]="'true' === rightSupplySelection.Value"
                    (change)="selectionChanged(rightSupplySelection, rightSupplyInput.checked.toString())">
                </span>
              }
            </div>
          }
          @if (universalSupplySelection) {
            <div class="modConnectionRow">
              <label [class.invalidConfigurationSelection]="isInvalidSelection(universalSupplySelection.Name)"
              for="universalSupplyInput" class="halfWidthInputLabel">Universal:</label>
              <input type="checkbox" class="checkboxInput" id="universalSupplyInput"
                #universalSupplyInput [checked]="'true' === universalSupplySelection.Value"
                (change)="selectionChanged(universalSupplySelection, universalSupplyInput.checked.toString())">
              @if (reversePipingSelection) {
                <span>
                  <label [class.invalidConfigurationSelection]="isInvalidSelection(reversePipingSelection.Name)"
                  for="reversePipingInput" class="modConnectionCheckboxLabel">Reverse Piping:</label>
                  <input type="checkbox" class="checkboxInput" id="reversePipingInput"
                    #reversePipingInput [checked]="'true' === reversePipingSelection.Value"
                    (change)="selectionChanged(reversePipingSelection, reversePipingInput.checked.toString())">
                </span>
              }
            </div>
          }
          @if (riserConnectionSelection) {
            <div class="modConnectionRow">
              <label class="halfWidthInputLabel">Riser Connection:</label>
              <select class="halfWidthInputField" #riserConnectionInput
                [class.invalidConfigurationSelection]="isInvalidSelection(riserConnectionSelection.Name)"
                (change)="selectionChanged(riserConnectionSelection, riserConnectionInput.value)"
                [value]="riserConnectionSelection.Value.toString()">
                @for (allowable of riserConnectionSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="riserConnectionSelection.Value && riserConnectionSelection.Value.toString() === allowable.Value"
                    [value]="allowable.Value">{{ allowable.Description }}
                  </option>
                }
              </select>
            </div>
          }
          @if (returnAirPanelSelection) {
            <div class="modConnectionRow">
              <label class="halfWidthInputLabel">Return Air Panel:</label>
              <select class="halfWidthInputField" #returnAirPanelInput
                [class.invalidConfigurationSelection]="isInvalidSelection(returnAirPanelSelection.Name)"
                (change)="selectionChanged(returnAirPanelSelection, returnAirPanelInput.value)"
                [value]="returnAirPanelSelection.Value.toString()">
                @for (allowable of returnAirPanelSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="returnAirPanelSelection.Value && returnAirPanelSelection.Value.toString() === allowable.Value"
                    [value]="allowable.Value">{{ allowable.Description }}
                  </option>
                }
              </select>
            </div>
          }
          @if (returnAirFinishSelection) {
            <div class="modConnectionRow">
              <label class="halfWidthInputLabel">Return Air Finish:</label>
              <select class="halfWidthInputField" #returnAirFinishInput
                [class.invalidConfigurationSelection]="isInvalidSelection(returnAirFinishSelection.Name)"
                (change)="selectionChanged(returnAirFinishSelection, returnAirFinishInput.value)"
                [value]="returnAirFinishSelection.Value.toString()">
                @for (allowable of returnAirFinishSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="returnAirFinishSelection.Value && returnAirFinishSelection.Value.toString() === allowable.Value"
                    [value]="allowable.Value">{{ allowable.Description }}
                  </option>
                }
              </select>
            </div>
          }
          @if (supplyAirGrilleSelection) {
            <div class="modConnectionRow">
              <label class="halfWidthInputLabel">Supply Air Grille:</label>
              <select class="halfWidthInputField" #supplyAirGrilleInput
                [class.invalidConfigurationSelection]="isInvalidSelection(supplyAirGrilleSelection.Name)"
                (change)="selectionChanged(supplyAirGrilleSelection, supplyAirGrilleInput.value)"
                [value]="supplyAirGrilleSelection.Value.toString()">
                @for (allowable of supplyAirGrilleSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="supplyAirGrilleSelection.Value && supplyAirGrilleSelection.Value.toString() === allowable.Value"
                    [value]="allowable.Value">{{ allowable.Description }}
                  </option>
                }
              </select>
            </div>
          }
          @if (supplyAirFinishSelection) {
            <div class="modConnectionRow">
              <label class="halfWidthInputLabel">Supply Air Finish:</label>
              <select class="halfWidthInputField" #supplyAirFinishInput
                [class.invalidConfigurationSelection]="isInvalidSelection(supplyAirFinishSelection.Name)"
                (change)="selectionChanged(supplyAirFinishSelection, supplyAirFinishInput.value)"
                [value]="supplyAirFinishSelection.Value.toString()">
                @for (allowable of supplyAirFinishSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="supplyAirFinishSelection.Value && supplyAirFinishSelection.Value.toString() === allowable.Value"
                    [value]="allowable.Value">{{ allowable.Description }}
                  </option>
                }
              </select>
            </div>
          }
          @if (opposedBladeDamperSelection) {
            <div class="modConnectionRow">
              <label [class.invalidConfigurationSelection]="isInvalidSelection(opposedBladeDamperSelection.Name)"
              for="opposedBladeDamperInput" class="halfWidthInputLabel">Opposed Blade Damper:</label>
              <input type="checkbox" class="checkboxInput" id="opposedBladeDamperInput"
                #opposedBladeDamperInput [checked]="'true' === opposedBladeDamperSelection.Value"
                (change)="selectionChanged(opposedBladeDamperSelection, opposedBladeDamperInput.checked.toString())">
            </div>
          }
          @if (paintOptionsSelection) {
            <div class="modConnectionRow">
              <label class="halfWidthInputLabel">Paint Options:</label>
              <select class="halfWidthInputField" #paintOptionsInput
                [class.invalidConfigurationSelection]="isInvalidSelection(paintOptionsSelection.Name)"
                (change)="selectionChanged(paintOptionsSelection, paintOptionsInput.value)"
                [value]="paintOptionsSelection.Value.toString()">
                @for (allowable of paintOptionsSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="paintOptionsSelection.Value && paintOptionsSelection.Value.toString() === allowable.Value"
                    [value]="allowable.Value">{{ allowable.Description }}
                  </option>
                }
              </select>
            </div>
          }
        </div>
        <div class="halfWidthConfigurationInput">
          @if (pipeDetailImagePath() && pipeDetailImagePath().length > 0) {
            <img class="pipeDetailImage"
              [src]="pipeDetailImagePath()" alt="Pipe Detail"/>
          }
          @if (handArrangementImagePath() && handArrangementImagePath().length > 0) {
            <img class="arrangementImage"
              [src]="handArrangementImagePath()" alt="Hand Arrangement"/>
          }
          @if (legendImagePath && legendImagePath.length > 0) {
            <img class="legendImage"
              [src]="legendImagePath" alt="Legend"/>
          }
        </div>
      </div>
    </div>
  }
</div>
